import styled from "styled-components";

const Button = styled.a`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  padding: 0.625em 1em 0.55em 1.125em;
  border-radius: 2em;
  font-size: 0.75em;
  font-weight: 700;
  background-color: var(--color-white);
  text-shadow: none;
  color: var(--color-black);
  white-space: nowrap;
  cursor: pointer;
  .arrow {
    position: relative;
    display: inline-block;
    margin-left: 0.25em;
    transform: translate3d(0,0.125em,0);
  }

  &.is-inversed {
    background-color: var(--color-black);
    color: var(--color-white);
  }
  &.is-small {
    padding: 0.5em 0.875em 0.375em 0.875em;
    font-size: 0.625em;
  }
  &.is-outlined {
    background-color: transparent;
    border: 1px solid;
    color: inherit;
  }

  .can-hover &:hover,
  &:active,
  .can-hover [href]:hover &,
  [href]:active & {
    background-color: var(--color-uyg);
    color: var(--color-black);
    &.is-faint {
      opacity: 1;
    }
  }
`;

export default Button;